import React from 'react';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '@components/common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function NewsNavPress() {
    const {locale} = useRouter();

    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {label: getLocaleContent(locale, 'page.press-news.title'), href: '/bao-chi-noi-ve-tnh'},
                ]}
            />
        </div>
    );
}

export default NewsNavPress;
